"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollParent = undefined;

var _getScrollParent2 = require("./getScrollParent");

var _getScrollParent3 = _interopRequireDefault(_getScrollParent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.getScrollParent = _getScrollParent3.default;


//////////////////
// WEBPACK FOOTER
// ./~/scroll-parent/lib/index.js
// module id = 1096
// module chunks = 0